export function isCalifornia(state: string): boolean {
  return state === 'CA' || state === 'AP'
}

export function isWashington(state: string | undefined): boolean {
  return state === 'WA'
}
